import { useState, useEffect } from "react";
import {
  useGetAdminProfileQuery,
  useUpdateAdminProfileMutation,
} from "../../features/api/adminApiSlice";
import FuelLoading from "../../pages/FuelLoading";
import "./adminProfile.scss"

export default function AdminProfile() {
  const { data: profile, isLoading } = useGetAdminProfileQuery();
  const [updateAdminProfile, { isLoading: isUpdating }] =
    useUpdateAdminProfileMutation();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (profile) {
      setName(profile.name || "");
      setEmail(profile.email || "");
      setPreviewUrl(profile.avatar || "");
    }
  }, [profile]);

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setSuccess(false);

    const formData = new FormData();
    formData.append("name", name.trim());
    formData.append("email", email.trim());
    if (selectedFile) formData.append("avatar", selectedFile);

    try {
      await updateAdminProfile(formData).unwrap();
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      alert("Failed to sync database updates.");
    }
  };

  if (isLoading || isUpdating) {
    return (
      <div className="profile-loading-box">
        <FuelLoading text="Updating credentials profiles..." />
      </div>
    );
  }

  return (
    <div className="admin-profile-page fuel-fade-in">
      <h2>Account Profile Settings</h2>
      <p>
        Manage your login identification signatures and avatar credentials
        display.
      </p>

      <form className="profile-card" onSubmit={handleSaveProfile}>
        {success && (
          <div className="profile-success-alert">
            🎉 Profile parameters overwritten successfully!
          </div>
        )}

        <div className="profile-layout-grid">
          {/* Avatar Photo Circle Slot */}
          <div className="avatar-uploader">
            <div className="avatar-frame">
              {previewUrl ? (
                <img src={previewUrl} alt="" />
              ) : (
                <span className="placeholder-avatar">👤</span>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              id="avatar-input"
              onChange={handleAvatarChange}
              style={{ display: "none" }}
            />
            <label htmlFor="avatar-input" className="file-trigger-btn">
              Upload Avatar Image
            </label>
          </div>

          {/* Form Content Inputs */}
          <div className="profile-fields">
            <label>
              Display Username
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </label>
            <label>
              Security System Email
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            <button type="submit" className="fuel-primary-btn save-profile-btn">
              💾 Save Profile Details
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
